module.exports = "/_next/static/images/shriram-79bbf007afb0e841afd8ed3f8c73fd1f.png";